import { Dispatch } from 'react';
import { DeckAction, DeckState } from '../context/DeckContextV3';
import { Block, Edge, Segment } from 'src/types/shared/blocksV3';
import BlockType from 'src/enums/blockType';
import { MIN_STAIR_VIABLE_BLOCK_HEIGHT } from 'src/constants/limits';
import getDefaultStair, {
	getDefaultStairForSegment,
} from './getDefaultStairV3';
import { toastError } from 'src/Toaster/Toast';

const handleAddStair = ({
	state,
	dispatch,
	block,
	edge,
	segment,
}: {
	state: DeckState;
	dispatch: Dispatch<DeckAction>;
	block: Block;
	edge: Edge;
	segment?: Segment;
}) => {
	if (
		block?.type == BlockType.DECKBOX &&
		block?.dimensions?.height <= MIN_STAIR_VIABLE_BLOCK_HEIGHT
	) {
		toastError({
			title: 'Deckbox height cannot accommodate landing',
			description: `You can’t add landing to a Deckbox with height less than or equal to ${MIN_STAIR_VIABLE_BLOCK_HEIGHT} inches.`,
		});
		return;
	}

	const data = segment
		? getDefaultStairForSegment({
				parentBlock: block,
				selectedBlockEdge: edge,
				selectedBlockSegment: segment,
			})
		: getDefaultStair({
				blocks: state.blocks,
				parentBlock: block,
				selectedBlockEdge: edge,
			});

	if (!data) {
		return;
	}

	const defaultStair = data.defaultStair;
	const addIntermediateLanding = data.addIntermediateLanding;
	const newSegment = data.newSegment;
	const updatedOldSegment = data.updatedOldSegment;

	if (defaultStair && updatedOldSegment) {
		const updatedBlock = { ...block };

		updatedBlock.edges = updatedBlock?.edges.map((ed) => {
			if (ed.id == edge.id) {
				const updatedEdge = { ...edge };

				updatedEdge.segments = updatedEdge.segments.map((seg) => {
					if (seg.id == updatedOldSegment.id) {
						return { ...updatedOldSegment };
					}
					return seg;
				});

				if (newSegment?.length) {
					updatedEdge.segments = [...updatedEdge.segments, newSegment];
				}

				return updatedEdge;
			} else {
				return ed;
			}
		});

		dispatch({
			type: 'UPDATE_BLOCK',
			payload: updatedBlock,
		});

		dispatch({
			type: 'ADD_STAIR',
			payload: defaultStair,
		});

		if (!addIntermediateLanding) {
			// Commented out to keep modal open after adding stair
			// dispatch({
			// 	type: 'SELECT_EDGE',
			// 	payload: { blockId: null, edgeLabel: null },
			// });
		}

		return { addIntermediateLanding, addedStairId: defaultStair.id || '' };
	} else {
		return;
	}
};

export default handleAddStair;
